/* eslint-disable */
import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import DatePicker from "react-multi-date-picker";
import { formatDate } from "helpers/DateCalculation";
import { useTranslation } from "react-i18next";
import { GlobalProvider } from "context/GlobalContext";

const MODULE_OPTIONS = [
  { value: "", label: "All Modules" },
  { value: "MOD_RESERVE", label: "Reserve" },
  { value: "MOD_ACCOUNT", label: "Account" },
  { value: "MOD_COMPANY", label: "Company" },
  { value: "MOD_ACTIVITY", label: "Activity" },
];

const ACTION_OPTIONS = [
  { value: "", label: "All Actions" },
  { value: "save", label: "Create" },
  { value: "update", label: "Update" },
  { value: "delete", label: "Delete" },
  { value: "webservice", label: "Webservice" },
];

const ActionLogFilter = () => {
  const { t } = useTranslation();
  const todayValue = new Date().toISOString().split("T")[0];

  const {
    setfilterActionLogDates,
    setreloadActionLogList,
    setfilterActionLogParams,
    isActionLogsLoading,
  } = useContext(GlobalProvider);

  // ── Date state ────────────────────────────────────────────────────────────
  const [selectedChecked, setSelectedChecked] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedDatesPick, setSelectedDatesPick] = useState([]);
  const [selectedDatesStr, setSelectedDatesStr] = useState("");
  const [dateWarning, setDateWarning] = useState(false);

  // ── Filter params state ───────────────────────────────────────────────────
  const [filterModule, setFilterModule] = useState("");
  const [filterAction, setFilterAction] = useState("");
  const [filterCustomerId, setFilterCustomerId] = useState("");
  const [filterFullname, setFilterFullname] = useState("");
  const [filterEmail, setFilterEmail] = useState("");

  const datePickerChangeHandler = (clickdate) => {
    if (!clickdate) return;
    const formatted = clickdate.map((d) => formatDate(new Date(d)));
    setSelectedDatesPick(formatted);
    setSelectedDatesStr(formatted.join(","));
    setSelectedChecked("actionlogdate");
  };

  const searchHandler = () => {
    // ── Apply date filter ──
    switch (selectedChecked) {
      case "daterange":
        if (fromDate && toDate && fromDate < toDate) {
          setfilterActionLogDates(fromDate + "|" + toDate);
        } else {
          setDateWarning(true);
          return;
        }
        break;
      case "todayradio":
        setfilterActionLogDates(todayValue);
        break;
      case "actionlogdate":
        setfilterActionLogDates(selectedDatesStr);
        break;
      default:
        setfilterActionLogDates("");
        break;
    }

    // ── Apply extra filters ──
    setfilterActionLogParams({
      module: filterModule,
      action: filterAction,
      entitycustomerid: filterCustomerId,
      fullname: filterFullname,
      email: filterEmail,
    });
  };

  const resetHandler = () => {
    setSelectedChecked("");
    setFromDate("");
    setToDate("");
    setSelectedDatesPick([]);
    setSelectedDatesStr("");
    setDateWarning(false);
    setFilterModule("");
    setFilterAction("");
    setFilterCustomerId("");
    setFilterFullname("");
    setFilterEmail("");
    setfilterActionLogDates("");
    setfilterActionLogParams({ module: "", action: "", entitycustomerid: "", fullname: "", email: "" });
    setreloadActionLogList(true);
  };

  return (
    <div className="collapse mt-3" id="filterCollapse">
      <div className="p-3 bg-gray-200">
        <h4 className="mb-3">{t("Filter")}</h4>
        <form onSubmit={(e) => e.preventDefault()}>

          {/* ===== BLOCK 1: Date ===== */}
          <div className="border rounded p-3 mb-3 bg-white">
            <p className="text-muted small fw-semibold text-uppercase mb-2 d-flex align-items-center gap-1">
              <span className="material-symbols-outlined" style={{ fontSize: "16px" }}>calendar_month</span>
              {t("Filter by Date")}
            </p>
            <div className="row g-3 align-items-start">

              {/* Date range */}
              <div className="col-lg-4">
                <div
                  className={`border rounded p-2 h-100 ${selectedChecked === "daterange" ? "border-primary bg-primary bg-opacity-10" : ""}`}
                  style={{ cursor: "pointer" }}
                  onClick={() => { setSelectedChecked("daterange"); setDateWarning(false); }}
                >
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <input
                      className="form-check-input mt-0"
                      type="radio"
                      name="dateGroup"
                      id="alDateRange"
                      value="daterange"
                      checked={selectedChecked === "daterange"}
                      onChange={() => { setSelectedChecked("daterange"); setDateWarning(false); }}
                    />
                    <label className="form-check-label fw-medium mb-0" htmlFor="alDateRange" style={{ cursor: "pointer" }}>
                      {t("Date Range")}
                    </label>
                  </div>
                  <div className="d-sm-flex gap-2">
                    <input
                      type="date"
                      className="form-control form-control-sm bg-white"
                      value={fromDate}
                      onClick={(e) => e.stopPropagation()}
                      onChange={(e) => { setFromDate(e.target.value); setSelectedChecked("daterange"); setDateWarning(false); }}
                    />
                    <input
                      type="date"
                      className="form-control form-control-sm bg-white mt-2 mt-sm-0"
                      value={toDate}
                      onClick={(e) => e.stopPropagation()}
                      onChange={(e) => { setToDate(e.target.value); setSelectedChecked("daterange"); setDateWarning(false); }}
                    />
                  </div>
                  {dateWarning && (
                    <p className="d-flex align-items-center gap-1 text-danger small mb-0 mt-1">
                      <span className="material-symbols-outlined" style={{ fontSize: "16px" }}>warning</span>
                      {t("End date should be greater than start date")}!
                    </p>
                  )}
                </div>
              </div>

              {/* Today */}
              <div className="col-lg-3">
                <div
                  className={`border rounded p-2 h-100 d-flex align-items-center gap-2 ${selectedChecked === "todayradio" ? "border-primary bg-primary bg-opacity-10" : ""}`}
                  style={{ cursor: "pointer" }}
                  onClick={() => { setSelectedChecked("todayradio"); setDateWarning(false); }}
                >
                  <input
                    className="form-check-input mt-0"
                    type="radio"
                    name="dateGroup"
                    id="alToday"
                    value="todayradio"
                    checked={selectedChecked === "todayradio"}
                    onChange={() => setSelectedChecked("todayradio")}
                  />
                  <label className="form-check-label fw-medium mb-0" htmlFor="alToday" style={{ cursor: "pointer" }}>
                    <span className="material-symbols-outlined align-middle me-1" style={{ fontSize: "16px" }}>today</span>
                    {t("Today")}
                  </label>
                </div>
              </div>

              {/* Multiple dates */}
              <div className="col-lg-5">
                <div
                  className={`border rounded p-2 h-100 ${selectedChecked === "actionlogdate" ? "border-primary bg-primary bg-opacity-10" : ""}`}
                  style={{ cursor: "pointer" }}
                  onClick={() => setSelectedChecked("actionlogdate")}
                >
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <input
                      className="form-check-input mt-0"
                      type="radio"
                      name="dateGroup"
                      id="alMultiple"
                      value="actionlogdate"
                      checked={selectedChecked === "actionlogdate"}
                      onChange={() => setSelectedChecked("actionlogdate")}
                    />
                    <label className="form-check-label fw-medium mb-0" htmlFor="alMultiple" style={{ cursor: "pointer" }}>
                      {t("Multiple Dates")}
                    </label>
                  </div>
                  <DatePicker
                    multiple
                    value={selectedDatesPick}
                    onChange={datePickerChangeHandler}
                    format="DD-MM-YYYY"
                    style={{ width: "100%" }}
                  />
                </div>
              </div>

            </div>
          </div>
          {/* ===== END BLOCK 1 ===== */}

          {/* ===== BLOCK 2: Module, Action, Customer ID ===== */}
          <div className="border rounded p-3 mb-3 bg-white">
            <p className="text-muted small fw-semibold text-uppercase mb-2 d-flex align-items-center gap-1">
              <span className="material-symbols-outlined" style={{ fontSize: "16px" }}>filter_list</span>
              {t("Filter by Module & Action")}
            </p>
            <div className="row g-3">

              {/* Module */}
              <div className="col-lg-4">
                <label className="form-label small text-muted mb-1">{t("Module")}</label>
                <select
                  className="form-select bg-white"
                  value={filterModule}
                  onChange={(e) => setFilterModule(e.target.value)}
                >
                  {MODULE_OPTIONS.map((o) => (
                    <option key={o.value} value={o.value}>{t(o.label)}</option>
                  ))}
                </select>
              </div>

              {/* Action */}
              <div className="col-lg-4">
                <label className="form-label small text-muted mb-1">{t("Action")}</label>
                <select
                  className="form-select bg-white"
                  value={filterAction}
                  onChange={(e) => setFilterAction(e.target.value)}
                >
                  {ACTION_OPTIONS.map((o) => (
                    <option key={o.value} value={o.value}>{t(o.label)}</option>
                  ))}
                </select>
              </div>

              {/* Customer ID */}
              <div className="col-lg-4">
                <label className="form-label small text-muted mb-1">{t("Customer ID")}</label>
                <div className="position-relative">
                  <input
                    type="text"
                    placeholder={t("e.g. R-1042")}
                    className="form-control bg-white"
                    value={filterCustomerId}
                    onChange={(e) => setFilterCustomerId(e.target.value)}
                  />
                  <span className="material-symbols-outlined position-absolute top-50 end-0 translate-middle-y me-2 text-muted" style={{ fontSize: "18px" }}>tag</span>
                </div>
              </div>

            </div>
          </div>
          {/* ===== END BLOCK 2 ===== */}

          {/* ===== BLOCK 3: User ===== */}
          <div className="border rounded p-3 mb-3 bg-white">
            <p className="text-muted small fw-semibold text-uppercase mb-2 d-flex align-items-center gap-1">
              <span className="material-symbols-outlined" style={{ fontSize: "16px" }}>person_search</span>
              {t("Filter by User")}
            </p>
            <div className="row g-3">

              {/* Full name */}
              <div className="col-lg-6">
                <label className="form-label small text-muted mb-1">{t("Full Name")}</label>
                <div className="position-relative">
                  <input
                    type="text"
                    placeholder={t("Search by name...")}
                    className="form-control bg-white"
                    value={filterFullname}
                    onChange={(e) => setFilterFullname(e.target.value)}
                  />
                  <span className="material-symbols-outlined position-absolute top-50 end-0 translate-middle-y me-2 text-muted" style={{ fontSize: "18px" }}>search</span>
                </div>
              </div>

              {/* Email */}
              <div className="col-lg-6">
                <label className="form-label small text-muted mb-1">{t("Email")}</label>
                <div className="position-relative">
                  <input
                    type="text"
                    placeholder={t("Search by email...")}
                    className="form-control bg-white"
                    value={filterEmail}
                    onChange={(e) => setFilterEmail(e.target.value)}
                  />
                  <span className="material-symbols-outlined position-absolute top-50 end-0 translate-middle-y me-2 text-muted" style={{ fontSize: "18px" }}>mail</span>
                </div>
              </div>

            </div>
          </div>
          {/* ===== END BLOCK 3 ===== */}

          {/* ===== Actions ===== */}
          <div className="d-flex gap-3 align-items-center justify-content-end">
            <Link
              to="#"
              className="d-flex gap-1 align-items-center text-secondary"
              onClick={resetHandler}
            >
              <span className="material-symbols-outlined icon-md">sync</span>
              <span className="fw-medium">{t("Reset")}</span>
            </Link>
            <button
              type="submit"
              className="btn btn-primary px-4 d-flex align-items-center gap-2"
              onClick={searchHandler}
              disabled={isActionLogsLoading}
            >
              {isActionLogsLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                  {t("Loading...")}
                </>
              ) : (
                <>
                  <span className="material-symbols-outlined align-middle" style={{ fontSize: "18px" }}>search</span>
                  {t("Apply Filter")}
                </>
              )}
            </button>
          </div>
          {/* ===== End Actions ===== */}

        </form>
      </div>
    </div>
  );
};

export default ActionLogFilter;
